import React, { useState } from 'react';
import { getApiUrl } from '../../utils/api';
import { useNotification } from '../../contexts/NotificationContext';

const DeleteFolderModal = ({ isOpen, onClose, onSuccess, folder }) => {
  const { showError, showSuccess } = useNotification();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!folder) return;
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(getApiUrl(`test-repository/folders/${folder.id}`), {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (res.ok) {
        showSuccess('Pasta excluída com sucesso');
        onSuccess && onSuccess();
        handleClose();
      } else {
        const errData = await res.json().catch(() => ({}));
        showError(errData.error || 'Erro ao excluir pasta');
      }
    } catch (err) {
      console.error('Erro ao excluir pasta:', err);
      showError('Erro ao excluir pasta');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setLoading(false);
    onClose && onClose();
  };

  if (!isOpen || !folder) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>Excluir Pasta</h2>
          <button className="modal-close" onClick={handleClose}>✕</button>
        </div>
        <div className="modal-body">
          <p>Tem certeza que deseja excluir a pasta <strong>{folder.name}</strong>?</p>
          <p>Esta ação não pode ser desfeita. Pastas com subpastas ou casos de teste não podem ser excluídas.</p>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-primary" onClick={handleClose}>Cancelar</button>
          <button type="button" className="btn btn-danger" onClick={handleDelete} disabled={loading}>
            {loading ? 'Excluindo...' : '🗑️ Excluir'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteFolderModal;